module.exports = __webpack_public_path__ + "static/avenir-next-b8d9f485f998b3abda1ad560432f0552.woff";